import { Flex, Text } from '@chakra-ui/react';
import { Banner, OutlineCard } from '@morressier/alembic';
import { BannerVariant } from '@morressier/alembic/_dist/cjs/components/banners/types';
import { IDecisionFeedback } from '@publishing-engine/domain/models';
import MultilineText from 'src/components/MultilineText';
import string from 'src/utils/string';

const getDecision = (
  feedback: IDecisionFeedback['payload']
): {
  variant: BannerVariant;
  label: string;
  comment?: string;
  reason?: string;
} => {
  switch (feedback.decision) {
    case 'accept':
      return { variant: 'success', label: 'Accepted' };
    case 'reject':
      return {
        variant: 'alert',
        label: 'Rejected',
        comment: feedback.comment,
        reason: feedback.reason
      };
    case 'withdraw': {
      const byWhom = feedback.roleType === 'author' ? ' by Author' : '';
      return {
        variant: 'attention',
        label: `Withdrawn${byWhom}`,
        comment: feedback.comment,
        reason: feedback.reason
      };
    }
  }
};

export const DecisionFeedback = ({
  payload
}: Pick<IDecisionFeedback, 'payload'>) => {
  const { variant, label, comment, reason } = getDecision(payload);

  return (
    <Flex flexDirection="column" gap={8}>
      <OutlineCard padding={4} width="100%">
        <Flex flexDirection="column" gap={6}>
          <Text textStyle="headingSection">Decision</Text>

          {payload.decision && (
            <Banner
              variant={variant}
              heading={string.capitalize(`Submission ${label}`)}
            />
          )}

          {reason && (
            <Flex gap={2} flexDirection={'column'}>
              <Text textStyle="headingItem">Reason</Text>
              <MultilineText textStyle="textBody" text={reason} />
            </Flex>
          )}

          {comment && (
            <Flex gap={2} flexDirection={'column'}>
              <Text textStyle="headingItem">Comment</Text>
              <MultilineText textStyle="textBody" text={comment} />
            </Flex>
          )}
        </Flex>
      </OutlineCard>
    </Flex>
  );
};
